import request from '../kernel/request'

export default {
	list(params) {
		return request.get('student', params)
	},
	roster(params) {
		return request.get('student/roster', params)
	},
	rosterEdu(params) {
		return request.get('student/rosterEdu', params)
	},
	rosterPaper(params) {
		return request.get('student/rosterPaper', params)
	},
	clazzList(params) {
		return request.get('student/clazz', params)
	},
	schedule(params) {
		return request.get('student/schedule', params)
	},
	earning(params) {
		return request.get('student/earning', params)
	},
	byClass(params) {
		return request.get('student/by/class', params)
	},
	page(params) {
		return request.get('student/page', params)
	},
	gcdf(params) {
		return request.get('student/gcdf', params)
	},
	wait(params) {
		return request.get('student/wait', params)
	},
	waitStu(params) {
		return request.get('student/waitStu', params)
	},
	transfer(params) {
		return request.get('student/transfer', params)
	},
	save(data) {
		return request.post(`student`, data)
	},
	update(data) {
		return request.put('student', data)
	},
	run(data) {
		return request.put('student/run', data)
	},
	del(data) {
		return request.put(`student/del`, data)
	},
	load(id) {
		return request.get('student/' + id)
	},
	delete(id) {
		return request.delete('student/' + id)
	},
	pay(params) {
		return request.get('student/pay', params)
	},
	notice(params){
		return request.post('student/notice', params)
	},
	refund(params) {
		return request.get('student/refund', params)
	},
	upSpecialty(id, params) {
		return request.put('student/upSpecialty/' + id, params)
	},
	upAdmit(id, params) {
		return request.put('student/upAdmit/' + id, params)
	},
	loadStudentByClassId(params) {
		return request.get('student/loadStudentByClass', params)
	},
	uploadAdmit: `${request.baseURL}/student/uploadAdmit`,
	studentRecord: {
		list(params) {
			return request.get('student/record', params)
		},
		save(data) {
			return request.post('student/record', data)
		},
		insert(data) {
			return request.post('student/record/insert', data)
		},
		insertSite(data) {
			return request.post('student/record/insertSite', data)
		},
		update(data) {
			return request.put('student/record/update', data)
		},
		load(id) {
			return request.get('student/record/' + id)
		},
		delete(id) {
			return request.delete('student/record/' + id)
		}
	},
	examPaper: {
		listBy(id) {
			return request.get('exam/paper/listBy/' + id)
		},
		save(data) {
			return request.post('exam/paper/save', data)
		},
		saveD(data) {
			return request.post('exam/paper/saveD', data)
		},
		update(data) {
			return request.put('exam/paper', data)
		},
		load(id) {
			return request.get('exam/paper/' + id)
		},
		delete(id) {
			return request.delete('exam/paper/' + id)
		},
		uploadPaper: `${request.baseURL}/exam/paper/uploadPaper`,
		uploadDiploma: `${request.baseURL}/exam/paper/uploadDiploma`,
		uploadGrade: `${request.baseURL}/exam/paper/uploadGrade`
	}
}